export default {

    
    'UnifiedLogin':'/yv2/token/UnifiedLogin',  //登录
    'GetUserInfoByUserId': '/yv2/api/GetUserInfoByUserId', // token取用户信息
    'getUserInfo' : '/mall/common/user-info', // 获取用户信息

    'address':'https://files.sciconf.cn/modules/address.js?v=3.8.9', //地址
    'iconUrl':'http://files.sciconf.cn/asset/module/fonticonpicker/icon-config.js?v=4.3.5',
    'getVideoSubjectList' : '/yv2/subject/list',                      // 获取学科列表

    'uploadImage' : (process.env.NODE_ENV == 'production' ? process.env.VUE_APP_API_BASE_URL + '/mall/common/upload-image' : process.env.VUE_APP_API_BASE_URL + '/mall/common/upload-image') + "?v=" +(+(new Date())),

    // 获取会议基本信息
    'getMeetingInfo' : '/mall/common/meeting',
    // 路由权限
    'getMenu' : '/mall/permis/menu',
    
    /****************    商品板块    ****************/
    // 获取商品分类列表
    'getGoodsTypeList' : '/mall/goods-category/get-goods-type-list', 
    // 获取商品分类详情
    'getGoodsTypeInfo' : '/mall/goods-category/get-goods-type-info', 
    // 获取全部商品分类
    'getAllGoodsType' : '/mall/goods-category/get-all-goods-type', 
    // 添加、修改、删除商品分类
    'setGoodsCategory' : '/mall/goods-category/set-type', 
    // 获取商品列表
    'getGoodsList' : '/mall/goods/get-goods-list', 
    // 添加、修改商品信息
    'setGoods' : '/mall/goods/set-goods', 
    // 删除商品
    'deleteGoods' : '/mall/goods/del-goods',
    'getGoodsInfo' : '/mall/goods/get-goods-info',
    // 商品分配信息
    'allocateGoods' : '/mall/goods/allocate-goods',
    // 商品设置分论坛配货
    'setForumAllocateNum' : '/mall/goods/set-forum-allocate-num',
    // 论坛商品列表
    'getForumGoodsList' : '/mall/forum-goods/get-forum-goods-list',
    // 论坛商品设置 上下架
    'setForumGoodsStatus' : '/mall/forum-goods/batch-set-status',


    /****************    会议配置    ****************/
    // 基本信息
    'websiteInfo' : '/mall/forum-website/info',
    // 默认首页
    'websiteDefault' : '/mall/forum-website/default',
    // 默认图片
    'websiteImage' : '/mall/forum-website/default-image',
    // 获取表单数据
    'getFormData' : '/mall/reg-form/get-form-data',
    // 修改表单显示、必填、删除状态
    'setFormStatus' : '/mall/reg-form/set-show',
    // 添加、修改表单内容
    'updateForm' : '/mall/reg-form/set-form',
    // 表单拖拽排序
    'formDragSort' : '/mall/reg-form/drag-sort',
    // 获取注册表单
    'getRegSelected' : '/mall/reg-form/get-reg-selected',

    /****************    PC网站配置    ****************/
    // PC网站配置
    'pcConfigInfo' : '/mall/forum-website/pc-set',
    // pc网站风格配置
    'pcConfigStyle' : '/mall/forum-website/pc-style',
    // pc首页网站
    'pcPageContent' : '/mall/forum-website/pc-modules',
    // 编辑
    'pcPageContentEdit' : '/mall/forum-website/pc-module',
    // 首页内容显示隐藏操作
    'pcPageContentSwitch' : '/mall/forum-website/pc-switch-show',
    // 新闻模块(列表)
    'pcNewsList' : '/mall/forum-news/list',
    // 新闻模块(更新)
    'pcNewsUpdate' : '/mall/forum-news/info',
    // 新闻模块(删除)
    'pcNewsDel' : '/mall/forum-news/del',
    // 新闻模块(排序)
    'pcNewsSort' : '/mall/forum-news/order-update',
    // 新闻模块(切换状态)
    'pcNewsSwitch' : '/mall/forum-news/switch-show',
    // banner模块(列表)
    'pcLinkList' : '/mall/forum-links/list',
    // banner模块(更新)
    'pcLinkInfo' : '/mall/forum-links/info',
    // banner模块(删除)
    'pcLinkDel' : '/mall/forum-links/del',
    // banner模块(排序)
    'pcLinkSort' : '/mall/forum-links/order-update',
    // banner模块(切换状态)
    'pcLinkSwitch' : '/mall/forum-links/switch-show',
    // guest模块(列表)
    'pcGuestList' : '/mall/forum-guest/list',
    // guest模块(更新)
    'pcGuestInfo' : '/mall/forum-guest/info',
    // guest模块(删除)
    'pcGuestDel' : '/mall/forum-guest/del',
    // guest模块(排序)
    'pcGuestSort' : '/mall/forum-guest/order-update',
    // guest模块(切换状态)
    'pcGuestSwitch' : '/mall/forum-guest/switch-show',
    // button模块(列表)
    'pcButtonList' : '/mall/forum-button/list',
    // button模块(更新)
    'pcButtonInfo' : '/mall/forum-button/info',
    // button模块(删除)
    'pcButtonDel' : '/mall/forum-button/del',
    // button模块(排序)
    'pcButtonSort' : '/mall/forum-button/order-update',
    // button模块(切换状态)
    'pcButtonSwitch' : '/mall/forum-button/switch-show',
    // 获取会议配置枚举
    'getConfigJson' : '/mall/forum-website/enum',
    // PC首页导航栏目配置-获取
    'getPcNavList' : '/mall/forum-website/pc-nav-modules',
    // PC首页导航栏目是否显示-保存
    'setPcNavSwitch' : '/mall/forum-website/pc-nav-switch-show',
    // PC首页导航栏目子栏目-保存
    'pcNavListUpdate' : '/mall/forum-website/pc-module',
    // PC首页导航栏目子栏目-删除
    'pcNavListDel' : '/mall/forum-website/pc-module-del',
    // PC首页导航栏目-排序
    'pcNavListSort' : '/mall/forum-website/order-update',

    /**********************  微网站配置相关  **************************/
    'getWebsiteInfo': '/mall/forum-website/mobile-set',// 获取微网站配置
    'clearCache': '/mall/forum-website/clear-mobile-cache',// 设置微网站配置
    'getMobileStyle': '/mall/forum-website/mobile-style',// 获取微网站风格配置
    'getMobileBanners': '/mall/forum-website/mobile-banners',// 获取微网站banner列表
    'getMobileBannerInfo': '/mall/forum-website/mobile-banner',// 获取微网站banner详情
    'deleteMobileBanner': '/mall/forum-website/mobile-banner-del',// 删除微网站banner
    'getMobileNavList': '/mall/forum-website/mobile-nav-modules',// 获取微网站导航栏目列表
    'setMobileNavSwitch': '/mall/forum-website/mobile-nav-switch-show',// 设置微网站导航栏目是否显示
    'deleteMobileNav': '/mall/forum-website/mobile-nav-del',// 删除微网站导航栏目
    'getAdList': '/mall/forum-website/mobile-adseats',// H5广告位列表
    'setAdSwitch': '/mall/forum-website/mobile-switch-adseat',// H5广告位是否显示
    'getMobileAds': '/mall/forum-website/mobile-ads',// 获取H5广告列表
    'getMobileAdInfo': '/mall/website/mobile-ad',// 获取H5广告详情
    'deleteMobileAd': '/mall/forum-website/mobile-ad-del',// 删除H5广告
    'setMobileSwitch': '/mall/forum-website/mobile-switch-ad',// H5广告是否显示
    'setMobileAdSort': '/mall/forum-website/mobile-ad-order-update',// H5广告排序
    'setMobileNavSort': '/mall/forum-website/mobile-nav-sort',// H5导航栏目排序
    'setMobileNavInfo': '/mall/forum-website/mobile-nav',// H5导航栏目保存
    'getH5NewsList': '/mall/forum-minisite-news/list',// H5新闻列表
    'getH5NewsInfo': '/mall/forum-minisite-news/info',// H5新闻详情
    'h5SwitchShow': '/mall/forum-minisite-news/switch-show',//更改H5新闻状态
    'deleteH5News': '/mall/forum-minisite-news/del',//删除H5新闻
    'h5NewsSort': '/mall/forum-minisite-news/order-update',//H5新闻排序

    /****************    用户管理    ****************/
    'setIdentity' : '/mall/identity/set-identity',// 设置身份类型
    'getIdentityList' : '/mall/identity/get-identity-list',// 获取身份类型列表
    'batchSaveStatus' : '/mall/identity/batch-save-status',// 批量设置身份类型状态
    'getRegList' : '/mall/reg/list',// 获取注册用户列表
    'getRegInfo' : '/mall/reg/get-reg-info',// 获取注册用户详情
    'setRegInfo' : '/mall/reg/set-reg',// 添加、修改注册用户信息
    'deleteReg' : '/mall/reg/batch-del-reg-status',// 删除注册用户
    'meetingRegForm' : 'mall/front-login/reg-from',// 注册表单数据
    'searchUser' : '/mall/reg/select-user',// 搜索用户
    
    'getForumConfig': '/mall/reg/get-forum-config', // 获取论坛注册参数配置、购票参数配置
    'setForumConfig': '/mall/reg/set-forum-config', // 设置论坛注册参数配置、购票参数配置

    /********************* 论坛管理  ******************/
    'getForumList' : '/mall/forum/get-forum-list',// 获取论坛列表
    'setForum' : '/mall/forum/set-forum',// 添加、修改论坛信息
    'setForumStatus' : '/mall/forum/batch-save-status',// 单个、批量修改论坛状态
    'getFourmInfo' : '/mall/forum/get-forum-info', // 获取论坛详情
    /********************* 订单管理  *******************/
    'getUserOrder' : '/mall/order/get-user-order',// 获取用户订单列表
    'getOrderList' : '/mall/order/get-order-list',// 获取订单列表
    'getPayType' : '/mall/order/get-pay-type',// 获取支付方式
    'getOrderInfo' : '/mall/order/get-order-details',// 获取订单详情
    'setOrderStatus' : '/mall/order/audit-order-status',// 修改订单状态
    'submitForumGoodsBind': '/mall/forum-goods/link-goods', // 论坛绑定门票
    'forumGoodsSort': '/mall/forum-goods/forum-goods-sort', // 论坛列表排序
    'submitCancelGoodsBind': '/mall/forum-goods/cancel-link-goods', // 解绑门票
    /********************* 促销,营销  *******************/
    'getSaleTiered': '/mall/sale/tiered',// 阶梯促销列表
    'tieredCreateUpdate': '/mall/sale/tiered-create-update',// 阶梯促销新增修改
    'saleLimitList' : '/mall/sale/limit', //限制规则列表
    'limitCreateUpdate' : '/mall/sale/limit-create-update', //限制规则新增修改
    'setTieredStatus' : '/mall/sale/tiered-status', //阶梯促销修改状态
    'setSaleLimitStatus' : '/mall/sale/limit-status', //限制规则修改状态
    'getSaleLimitEnum' : '/mall/sale/limit-enum', //获取限制规则枚举
} 